import { createFileRoute } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

const faqs = [
  ["Mistä materiaaleista tuotteet on valmistettu?", "Suurin osa kalusteista on koivuvaneria tai massiivipuuta ja viimeistelty lapsiystävällisillä pintakäsittelyillä. Tuotekohtaiset materiaali-, turvallisuus- ja vaatimustenmukaisuustiedot ilmoitetaan jokaisen tuotteen omalla sivulla."],
  ["Mille ikäryhmälle tuotteet sopivat?", "Ikäsuositukset vaihtelevat tuotteen ja valmistajan mukaan. Tarkista aina tuotekohtainen ikäsuositus tuotesivun tuotetiedoista — se on aina ensisijainen tieto."],
  ["Onko kiipeilyteline turvallinen pienelle lapselle?", "Tuotekohtaiset turvallisuustiedot, ikäsuositus ja mahdollinen enimmäiskuormitus ilmoitetaan jokaisen tuotteen omalla sivulla valmistajan tietojen mukaisesti. Aikuisen valvonta on aina suositeltavaa harjoittelun alussa."],
  ["Mikä on toimitusaika Suomessa?", "Varastossa olevat tuotteet pyritään lähettämään 1–2 arkipäivän kuluessa. Toimitus Postin tai Matkahuollon kautta 3–7 arkipäivässä koko Suomeen."],
  ["Mitä toimitus maksaa?", "Toimitus on aina ilmainen — kaikkiin tilauksiin koko Suomeen, ilman alarajaa."],
  ["Voinko palauttaa tuotteen?", "Kyllä. 30 päivän palautusetu ilman perusteluja (lakisääteinen 14 pv peruuttamisoikeus), kunhan tuote on käyttämätön ja alkuperäispakkauksessa."],
  ["Miten huollan koivuvanerituotteita?", "Pyyhi pinta kostealla liinalla ja miedolla saippualla. Vältä runsasta vettä ja voimakkaita pesuaineita. Säilytä huonelämpötilassa, vältä jatkuvaa suoraa auringonpaistetta."],
  ["Tuleeko tuote koottuna?", "Suurin osa tuotteista toimitetaan litteässä pakkauksessa valmistajan kokoamisohjeiden kanssa. Tuotekohtainen kokoamistieto löytyy tuotesivun tuotetiedoista."],
] as const;

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(([q, a]) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
};

export const Route = createFileRoute("/ukk")({
  head: () => ({
    meta: [
      { title: "UKK — toimitus, materiaalit & palautus | Montessori24" },
      { name: "description", content: "Usein kysytyt kysymykset Montessori24-kaupasta: toimitusaika ja -kulut Suomeen, materiaalit ja turvallisuus, 30 päivän palautusetu." },
      { property: "og:title", content: "UKK — toimitus, materiaalit & palautus" },
      { property: "og:description", content: "Vastauksia toimituksesta, materiaaleista ja 30 päivän palautusedusta." },
      { property: "og:url", content: "https://montessori24.fi/ukk" },
    ],
    links: [{ rel: "canonical", href: "https://montessori24.fi/ukk" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(faqJsonLd) },
    ],
  }),
  component: Faq,
});

function Faq() {
  return (
    <Layout>
      <section className="container-prose pt-16 pb-24 md:pt-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <span className="text-xs uppercase tracking-[0.25em] text-muted-foreground">Ohjeet</span>
            <h1 className="mt-3 text-5xl text-foreground md:text-6xl text-balance">Usein kysyttyä</h1>
            <p className="mt-6 text-sm text-muted-foreground">
              Etkö löytänyt vastausta? Kirjoita meille osoitteeseen{" "}
              <a className="text-foreground underline-offset-4 hover:underline" href="mailto:asiakaspalvelu@montessori24.fi">
                asiakaspalvelu@montessori24.fi
              </a>.
            </p>
          </div>
          <div className="md:col-span-7 md:col-start-6">
            <dl className="divide-y divide-border border-y border-border">
              {faqs.map(([q, a]) => (
                <details key={q} className="group py-6">
                  <summary className="flex cursor-pointer list-none items-start justify-between gap-6 text-base text-foreground">
                    <span>{q}</span>
                    <span className="mt-1 text-xl text-muted-foreground transition-transform group-open:rotate-45">+</span>
                  </summary>
                  <p className="mt-4 max-w-prose text-sm leading-relaxed text-muted-foreground">{a}</p>
                </details>
              ))}
            </dl>
          </div>
        </div>
      </section>
    </Layout>
  );
}
